@if (footerSlot?.controls(); as controls) {
  <ng-container [ngTemplateOutlet]="controls" />
}
<nav #nav aria-label="Breadcrumb" class="relative flex min-w-0 flex-1 items-center" [attr.title]="path()">
  <ol class="flex min-w-0 items-center gap-2 text-[12px] leading-8">
    @for (crumb of crumbs(); track $index; let last = $last; let first = $first; let i = $index) {
      <!-- Earlier crumbs give way first; the last keeps the most room. -->
      <!-- A collapsed "…" keeps its size; only the item (and a revealed crumb) gives way. -->
      <li
        class="flex min-w-0 items-center gap-2"
        [style.flex-shrink]="last ? 1 : collapsed() && !revealed().has(i) ? 0 : 3"
      >
        @if (!first) {
          <app-icon class="shrink-0 text-gray-500" name="sapphire-chevron-right" [size]="12" />
        }
        @if (!last && collapsed() && !revealed().has(i)) {
          <!-- A path too long for the row reads "… › … › item"; a "…" shows its crumb (Johanna, 2026-10-21). -->
          <button
            type="button"
            class="shrink-0 rounded px-1 text-gray-600 hover:bg-gray-100 hover:text-blue-600"
            [attr.aria-label]="'Show ' + crumb.label"
            [title]="crumb.label"
            (click)="reveal(i)"
          >
            …
          </button>
        } @else if (crumb.action && !last) {
          <button
            type="button"
            class="min-w-0 truncate rounded text-gray-600 hover:text-blue-600 hover:underline"
            (click)="crumb.action()"
          >
            {{ crumb.label }}
          </button>
        } @else {
          <span class="min-w-0 truncate" [class.text-gray-950]="last" [class.text-gray-600]="!last" [attr.aria-current]="last ? 'page' : null">
            {{ crumb.label }}
          </span>
        }
      </li>
    }
  </ol>
  <!-- The whole path on one line, unseen: its width says whether the row can show it without collapsing. -->
  <span #measure aria-hidden="true" class="pointer-events-none invisible absolute left-0 top-0 whitespace-nowrap text-[12px] leading-8">
    @for (crumb of crumbs(); track $index; let first = $first) {
      @if (!first) {
        <span class="inline-block w-[12px] mx-2"></span>
      }
      <span>{{ crumb.label }}</span>
    }
  </span>
</nav>
@if (status(); as status) {
  <span class="shrink-0 text-[12px] leading-8 text-gray-600">{{ status }}</span>
}
@if (footerSlot?.count(); as count) {
  <span class="ml-auto shrink-0"><ng-container [ngTemplateOutlet]="count" /></span>
}
